import assign from 'lodash/assign';
import findBy from 'lodash/find';
import map from 'lodash/map';

import api from '../../utils/api';
import constants from '../constants';
import Area from '../../models/Area';
import FeedbackListing from '../../models/FeedbackListing';
import { logError } from '@zg-rentals/log-error';
import { getGlobalLogger } from '@zg-rentals/logger-base';

const logger = getGlobalLogger('actions');

const ListingActions = {
  fetchListingByAliasEncoded({ aliasEncoded = '', components = '' } = {}) {
    if (aliasEncoded) {
      return function (dispatch) {
        let apiArgs = {
          alias: aliasEncoded,
          components: components || constants.FETCH_ALL_COMPONENTS,
          type: 'unit',
          unit: '',
          validate: false,
        };
        return dispatch(api.listing.fetchByAlias(apiArgs))
          .then((apiResponse) => {
            if (apiResponse.success && apiResponse.data) {
              return apiResponse.data;
            } else {
              throw {
                listingNotFound: true,
              };
            }
          })
          .then((processedBuilding) => {
            return dispatch(ListingActions.validateAliasEncoded(processedBuilding, aliasEncoded));
          })
          .then((buildingAndListing) => {
            dispatch(ListingActions.setListing(buildingAndListing.listing));
            return buildingAndListing;
          })
          .then((buildingAndListing) => {
            return dispatch(ListingActions.setAreaFromBuilding(buildingAndListing.processedBuilding));
          })
          .catch((errorResponse) => {
            logError({
              error: errorResponse,
              errorType: 'FetchListingByAliasEncoded',
              context: {
                location: 'ListingActions#fetchListingByAliasEncoded',
              },
            });

            return {
              success: false,
              error: errorResponse,
            };
          });
      };
    }
  },
  setListing(listing) {
    return (dispatch) => {
      return dispatch({
        type: constants.SET_CURRENT_LISTING,
        payload: listing,
      });
    };
  },
  validateAliasEncoded(processedBuilding = {}, aliasEncoded) {
    return function () {
      let matchedUnit = processedBuilding.listings.filter((unit) => {
        return unit.aliasEncoded === aliasEncoded;
      });

      if (matchedUnit.length === 0) {
        logger?.debug({
          fetchListingError: 'ALIAS_NOT_MATCHED',
          message: 'SHOULD_404',
        });
        throw {
          changeHttpStatus: 404,
        };
      }

      return {
        processedBuilding,
        listing: matchedUnit[0],
      };
    };
  },
  setAreaFromBuilding(building = {}) {
    return function (dispatch) {
      const { areas = {}, geo = {} } = building;

      if (!areas) {
        logger?.debug('ListingActions - No building information to set area');
      }

      const associatedZip = {};
      const foundZip = findBy(areas.links, (link) => link.type === 'zip');

      if (foundZip) {
        associatedZip.zip = Area(foundZip).name;
      }

      return dispatch({
        type: constants.SET_CURRENT_AREA,
        payload: assign(
          {},
          Area(areas.specific),

          // todo: not sure how to break this down.
          // this seems like a temp solution that can be re-investigated
          // once the requirements for all the brands are completed
          associatedZip,

          // temp fix to add lat/lon
          {
            lat: geo.lat,
            lon: geo.lon,
          },
        ),
      });
    };
  },
  getFeedbackListings(body) {
    return (dispatch) => {
      return dispatch(api.user.getFeedbackListings(body)).then((response) => {
        return map(response.listings, (listing) => FeedbackListing(listing));
      });
    };
  },
};

export default ListingActions;
